<!-- 流程和物流记录 -->
<template>
    <div class="container">
        <div class="header">
            <Input class="w200 mr-24" type="text" v-model="storePrams.keywords" placeholder="录入溯源码数据支持扫码枪"></Input>
            <Button class="theme-bc" icon="ios-search" type="warning" @click="goSearch">确认搜索</Button>
        </div>
        <div class="content">
            <div>
                <Table :columns="columnsTable" :data="dataTable" border>
                    <template slot-scope="{ row }" slot="logistics">
                        <div v-if="row.logistics">{{ row.logistics.logistics }} {{ row.logistics.logistics_number }}</div>
                    </template>
                </Table>
            </div>
            <div class="mt-24 ta-r">
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>
    </div>
</template>

<script>
import { 
    incoming_qrcode_all, 
} from '@/api/index';
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
                keywords: "",
            },
            total: 0,
            columnsTable: [
                { type: 'index', width: 60, align: 'center' },
                { title: "产品码", key: "qrcode_number", align: "center" },
                { title: "流程和物流信息", slot: "logistics", align: "center" },
            ],
            dataTable: [],
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList(){
            incoming_qrcode_all(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index){
            this.storePrams.page = index;
            this.getList();
        },
        // 确认搜索
        goSearch(){
            this.getList();
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53C41A;
    border-color: #53C41A;
    box-shadow: -1px 0 0 0 #53C41A;
    border-radius: 5px;
    color: #fff;
    z-index: 1;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.ta-r {
    text-align: right;
}
</style>